module.exports = "https://pm2019.reeltime.no/public/images/map_pin_gold@1x.64703f02.png";